import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChargerOnboarderComponent } from './charger-onboarder.component';
import { ConfigureChargerComponent } from './components/configure-charger/configure-charger.component';
import { BoxComponent } from '../shared/components/box/box.component';
import { TranslateModule } from '@ngx-translate/core';
import { VerticalStepperComponent } from '../shared/components/verical-stepper/vertical-stepper.component';
import { ButtonComponent } from '../shared/components/button/button.component';
import { ProgressCircleComponent } from '../shared/components/progress-circle/progress-circle.component';
import { CheckConnectionComponent } from './components/check-connection/check-connection.component';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { SpinnerComponent } from '../shared/components/spinner/spinner.component';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { ConnectionTestResultsComponent } from './components/connection-test-results/connection-test-results.component';
import { LanguageDatePipe } from '../shared/pipes/date.pipe';
import { InfoBoxComponent } from '../shared/components/info-box/info-box.component';
import { AddInformationComponent } from './components/add-information/add-information.component';
import { SharedModule } from '../shared/shared.module';
import { AddAddressComponent } from './components/add-address/add-address.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MapComponent } from '../shared/components/map/map.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ClaimingCodeComponent } from './components/claiming-code/claiming-code.component';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';

@NgModule({
  imports: [
    CommonModule,
    BoxComponent,
    VerticalStepperComponent,
    TranslateModule.forRoot(),
    ButtonComponent,
    ProgressCircleComponent,
    MatFormField,
    ReactiveFormsModule,
    MatIcon,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    SpinnerComponent,
    InfoBoxComponent,
    LanguageDatePipe,
    SharedModule,
    MatTooltip,
    MapComponent,
    MatAutocompleteModule,
    CdkCopyToClipboard,
  ],
  declarations: [
    ChargerOnboarderComponent,
    ConfigureChargerComponent,
    CheckConnectionComponent,
    ConnectionTestResultsComponent,
    AddInformationComponent,
    AddAddressComponent,
    ClaimingCodeComponent,
  ],
  providers: [LanguageDatePipe],
})
export class ChargerOnboarderModule {}
